"use strict";

var _regeneratorRuntime = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator = require("/codebuild/output/src013157826/src/gardner/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CssEditor = void 0;

var react_1 = __importDefault(require("react"));

var theme_ui_1 = require("theme-ui");

var react_codemirror2_1 = require("react-codemirror2");

var csstree_validator_1 = require("csstree-validator/dist/csstree-validator");

require("codemirror/lib/codemirror.css");

require("codemirror/addon/lint/lint.css");

if (typeof navigator !== 'undefined') {
  // SSR https://github.com/JedWatson/react-codemirror/issues/77
  require('codemirror/mode/css/css');

  require('codemirror/addon/lint/lint');

  require('codemirror/addon/lint/css-lint');
}
/**
 * Making it a proper component interferes with CodeMirror rendering somehow (cursor disappearance?)
 */


var CssEditor = function CssEditor(_ref) {
  var cssCode = _ref.cssCode,
      setCssCode = _ref.setCssCode,
      cssValid = _ref.cssValid,
      setCssValid = _ref.setCssValid;
  return react_1.default.createElement(theme_ui_1.Box, {
    sx: Object.assign({
      marginBottom: "1em",
      borderRadius: "8px",
      ".CodeMirror": {
        maxHeight: "20em",
        ".CodeMirror-scroll": {
          height: "100%"
        }
      }
    }, cssValid ? {} : styles.invalid)
  }, react_1.default.createElement(react_codemirror2_1.Controlled, {
    value: cssCode,
    options: {
      mode: 'css',
      lineNumbers: true,
      gutters: ["CodeMirror-lint-markers"],
      lint: {
        onUpdateLinting: function onUpdateLinting(annotationsNotSorted) {
          setCssValid(annotationsNotSorted.length === 0);
        },
        getAnnotations: function getAnnotations(content, options, codeMirror) {
          return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var errors, cm;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    errors = csstree_validator_1.validate(content); // because SSR =\

                    _context.next = 3;
                    return Promise.resolve().then(function () {
                      return __importStar(require('codemirror'));
                    });

                  case 3:
                    cm = _context.sent;
                    return _context.abrupt("return", errors.map(function (it) {
                      return {
                        from: cm.Pos(it.line - 1, it.column - 1),
                        message: it.message || it.reference
                      };
                    }));

                  case 5:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }))();
        }
      }
    },
    onBeforeChange: function onBeforeChange(editor, data, value) {
      setCssCode(value);
    },
    onKeyHandled: function onKeyHandled(_, __, e) {
      return e.stopPropagation();
    }
  }));
};

exports.CssEditor = CssEditor;
var styles = {
  invalid: {
    borderColor: "var(--ck-color-base-error,#db3700)",
    boxShadow: "0 0 0 2px var(--ck-color-focus-error-shadow,rgba(255,64, 31, 0.3))"
  }
};